module.exports = __webpack_public_path__ + "img/w3_package_grey.e2fccee1.png";